export const getInvolved = {
  hero: {
    badge: "Make a Difference",
    title: "Join Us in Transforming Lives",
    subtitle: "Every contribution, whether time, skills, or resources, helps us bring hope, dignity, and opportunity to refugees and vulnerable communities across the Uganda.",
    tagline: "Together, we can build a future where every person has the chance to thrive.",
    donate: "Donate Now",
    volunteer: "Become a Volunteer",
  },
  ways: {
    title: "Ways to Make an Impact",
    subtitle: "Choose how you'd like to contribute to our mission of empowering communities and creating lasting change.",
    learnMore: "Learn more",
    takeAction: "Take action",
    items: {
      volunteer: {
        title: "Volunteer With Us",
        description: "Share your skills and time to directly support refugees. From teaching to healthcare, every hour makes a difference.",
      },
      partner: {
        title: "Partner With Us",
        description: "Join forces with organizations and businesses to amplify our impact. Strategic partnerships create sustainable change.",
      },
      donate: {
        title: "Donate to Support Refugees",
        description: "Your financial contribution provides shelter, food, education, and opportunities for families in need.",
      },
      sponsor: {
        title: "Sponsor a Family",
        description: "Provide monthly support to help a refugee family become self-reliant through skills training and resources.",
      },
      community: {
        title: "Join Community Programs",
        description: "Participate in our community initiatives that bring people together to learn, grow, and support each other.",
      },
      advocate: {
        title: "Become an Advocate",
        description: "Raise awareness about refugee rights and challenges. Your voice can help change policies and perceptions.",
      },
    },
  },
  stats: {
    title: "Our Impact in Numbers",
    subtitle: "Together with our partners and supporters, we've achieved meaningful results.",
    quote: "We don't just provide aid; we empower individuals to become leaders in their own communities.",
    items: {
      families: {
        value: "20+",
        label: "Families Supported",
      },
      youth: {
        value: "80+",
        label: "Youth Empowered",
      },
      communities: {
        value: "4+",
        label: "Communities Reached",
      },
      volunteers: {
        value: "10+",
        label: "Active Volunteers",
      },
    },
  },
  testimonials: {
    title: "Voices of Impact",
    subtitle: "Hear from those whose lives have been transformed by our programs.",
    impact: {
      title: "Every Story Matters",
      description: "Behind every statistic is a human story of resilience, hope, and transformation. Your support makes these stories possible.",
    },
    items: {
      refugee: {
        name: "Marie K.",
        role: "Program Beneficiary",
        quote: "BridgeCore gave me digital skills that changed my life. Now I can work from anywhere and support my family with dignity. I'm not just a refugee anymore—I'm a professional.",
      },
      volunteer: {
        name: "James T.",
        role: "International Volunteer",
        quote: "Working with BridgeCore showed me the power of community. The resilience and hope of the people here is truly inspiring. It's not just about giving—it's about learning.",
      },
    },
  },
  news: {
    title: "Latest News",
    viewAll: "View All Updates",
    news1: {
      date: "Jan 2026",
    },
    news2: {
      date: "Dec 2025",
    },
    news3: {
      date: "Nov 2025",
    },
    items: {
      education: {
        title: "New Digital Literacy Program Reaches 20+ Students",
        excerpt: "Our latest initiative brings computer training to refugee communities, opening doors to remote work opportunities.",
      },
      partnership: {
        title: "Strategic Partnership with Divine Foundation Announced",
        excerpt: "A new collaboration that will expand our reach and impact across three major refugee settlements.",
      },
      impact: {
        title: "Annual Impact Report Shows 15% Growth in Community Reach",
        excerpt: "Our programs have expanded to serve more families than ever before, thanks to your continued support.",
      },
    },
  },
  donation: {
    title: "Make a Donation",
    subtitle: "Your financial support directly impacts lives. Choose how you'd like to contribute.",
    oneTime: "One-Time",
    recurring: "Monthly",
    amounts: {
      custom: "Custom Amount"
    },
    button: "Donate Now",
    secure: "Secure payment powered by Stripe"
  },
  volunteer: {
    title: "Become a Volunteer",
    subtitle: "Join our team of dedicated volunteers making a real difference on the ground.",
    form: {
      fullName: "Full Name",
      fullNamePlaceholder: "Enter your full name",
      email: "Email Address",
      emailPlaceholder: "your.email@example.com",
      phone: "Phone Number",
      phonePlaceholder: "+256 XXX XXX XXX",
      location: "Your Location",
      locationPlaceholder: "City, Country",
      skills: "Skills & Expertise",
      skillsPlaceholder: "e.g., Medical, Teaching, Construction, Administration...",
      availability: "Availability",
      availabilityPlaceholder: "e.g., Weekends, Full-time, 2 weeks per month...",
      motivation: "Why do you want to volunteer?",
      motivationPlaceholder: "Tell us what motivates you to join our mission...",
      submit: "Submit Application",
      submitting: "Submitting...",
      successMessage: "Thank you! We'll contact you soon.",
      errorMessage: "Something went wrong. Please try again."
    }
  },
  campaigns: {
    title: "Active Fundraising Campaigns",
    subtitle: "Support specific initiatives that are making an immediate impact.",
    raised: "raised",
    goal: "goal",
    donors: "donors",
    daysLeft: "days left",
    share: "Share Campaign"
  },
  partnership: {
    title: "Partner With Us",
    subtitle: "Organizations and businesses can amplify our impact through strategic partnerships.",
    form: {
      orgName: "Organization Name",
      orgNamePlaceholder: "Your organization name",
      contactName: "Contact Person",
      contactNamePlaceholder: "Full name",
      email: "Email Address",
      emailPlaceholder: "contact@organization.com",
      phone: "Phone Number",
      phonePlaceholder: "+XXX XXX XXX XXX",
      partnershipType: "Partnership Type",
      partnershipTypePlaceholder: "e.g., Corporate Sponsorship, In-kind Donation, Volunteer Program...",
      message: "Tell us about your interest",
      messagePlaceholder: "Describe how you'd like to partner with us and what resources you can offer...",
      submit: "Send Inquiry",
      submitting: "Sending...",
      successMessage: "Thank you! We'll be in touch shortly.",
      errorMessage: "Failed to send. Please try again."
    }
  },
  finalCta: {
    title: "Together We Can Create Change",
    description: "Every action, no matter how small, contributes to something greater. Join our mission to empower refugees and build stronger communities.",
    donate: "Start Donating",
    volunteer: "Volunteer Today",
    partner: "Become a Partner",
    contactNote: "Questions? We'd love to hear from you.",
  }
};